import { temAcesso } from '@/shared/auth/temAcesso'

const Relatorios = () => import('./Relatorios.vue')
const RelatorioGeral = () => import('./RelatorioGeral.vue')
const PorCompetencia = () => import('./PorCompetencia.vue')
const PorCapa = () => import('./PorCapa.vue')
const RelatorioDespesas = () => import('./RelatorioDespesas.vue')
const RelatorioPendencias = () => import('./RelatorioPendencias.vue')


export default {
    path: 'convenios/relatorios',
    name: 'Convenios_Relatorios',
    component: Relatorios,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CONV-REL-00')) {
            next()
        }
    },
    children: [
        {
            path: 'relatoriogeral',
            name: 'Convenios_Relatorios_RelatorioGeral',
            component: RelatorioGeral,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONV-REL-01')) {
                    next()
                }
            }
        },
        {
            path: 'porcompetencia',
            name: 'Convenios_Relatorios_PorCompetencia',
            component: PorCompetencia,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONV-REL-03')) {
                    next()
                }
            }
        },
        {
            path: 'porcapa',
            name: 'Convenios_Relatorios_PorCapa',
            component: PorCapa,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONV-REL-04')) {
                    next()
                }
            }
        },
        {
            path: 'despesas',
            name: 'Convenios_Relatorio_Despesas',
            component: RelatorioDespesas,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONV-REL-02')) {
                    next()
                }
            }
        },
        {
            path: 'pendencias',
            name: 'Convenios_Relatorio_Pendencias',
            component: RelatorioPendencias,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONV-REL-02')) {
                    next()
                }
            }
        }
        
        
    ]
}
